import { useEffect, useRef, useSyncExternalStore } from "react";

/** iOS-style collapsing large titles: page title shrinks into the top bar when scrolled away. */
let compact = { title: "", visible: false };
const subs = new Set();
const emit = () => subs.forEach((f) => f());
export const titleStore = {
  subscribe: (f) => (subs.add(f), () => subs.delete(f)),
  get: () => compact,
  set: (v) => {
    compact = v;
    emit();
  },
};
export const useCompactTitle = () => useSyncExternalStore(titleStore.subscribe, titleStore.get, titleStore.get);

export function LargeTitle({ children, title, className = "", testId }) {
  const ref = useRef(null);
  const text = title || (typeof children === "string" ? children : "");
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(([e]) => titleStore.set({ title: text, visible: !e.isIntersecting && e.boundingClientRect.top < 0 }), { rootMargin: "-64px 0px 0px 0px", threshold: 0 });
    io.observe(el);
    return () => {
      io.disconnect();
      titleStore.set({ title: "", visible: false });
    };
  }, [text]);
  return (
    <h1 ref={ref} className={`origin-left text-[32px] font-black tracking-[-0.03em] text-white sm:text-[40px] ${className}`} data-testid={testId}>
      {children}
    </h1>
  );
}
